'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps", "children"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useMessageError } from "../hooks/useMessageError.js";
import { useChatRuntimeContext } from "../internals/useChatRuntimeContext/index.js";
import { useMessageContext } from "./internals/MessageContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageError = /*#__PURE__*/React.forwardRef(function MessageError(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps,
      children
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  void ownerStateProp;
  const messageContext = useMessageContext();
  const {
    messageId
  } = messageContext;
  const chatError = useMessageError(messageId);
  const runtime = useChatRuntimeContext(true);
  const retry = React.useCallback(async () => {
    if (!runtime || !messageId) {
      return;
    }
    await runtime.actions.retry(messageId);
  }, [runtime, messageId]);
  const ownerState = React.useMemo(() => _extends({}, messageContext, {
    chatError,
    // Retry only runs on user messages (stream failures attach errors to the
    // assistant id, but the action no-ops there) — keep `retryable` honest so
    // slots don't render a button that does nothing.
    retryable: (chatError?.retryable ?? false) && messageContext.role === 'user',
    retry
  }), [messageContext, chatError, retry]);
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: chatError ? slotProps?.root : undefined,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      role: 'alert'
    }
  });
  if (!chatError) {
    return null;
  }
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: children ?? chatError.message
  }));
});
if (process.env.NODE_ENV !== "production") MessageError.displayName = "MessageError";